module.exports = __webpack_public_path__ + "static/media/envelope.28273fe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/DogProfile/envelope.svg
// module id = 339
// module chunks = 0